"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypography = void 0;
const getTypography = (text) => {
    const h1 = {
        color: text.primary,
        fontSize: '2rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const h2 = {
        color: text.primary,
        fontSize: '1.75rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const h3 = {
        color: text.secondary,
        fontSize: '1.5rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const h4 = {
        color: text.primary,
        fontSize: '1.25rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const h5 = {
        color: text.primary,
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const h6 = {
        color: text.primary,
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
    };
    const subtitle1 = {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
    };
    const subtitle2 = {
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
    };
    const body1 = {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    };
    const body2 = {
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 400,
    };
    const button = {
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 700,
    };
    const caption = {
        color: text.primary,
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 400,
    };
    return {
        body1,
        body2,
        button,
        caption,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        subtitle1,
        subtitle2,
    };
};
exports.getTypography = getTypography;
